import FeatureSlider from "../components/FeatureSlider.vue";

bootVue('.vue-feature-slider', FeatureSlider, {
  jsonProps: ['features'],
  beforeMount: (el, props) => { },
});